import type { InsertCommentMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertCommentDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface InsertCommentInput {
  ConversationId: string;
  Content: string;
}

/**
 * Flag-gated wrapper (RSP-6496). Both paths return `{ Id }` so
 * `useComments.tinycomments_reply` reads `.Id` regardless of which ran.
 */
export const useInsertComment = createMutationHook({
  name: 'insertComment',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.comment.insert.mutationOptions({ onSuccess }),
  mapInput: (input: InsertCommentInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.comment.commentsByConversationId.queryKey(),
  ],
  mapResponse: (result: { Id: string }): { Id: string } => ({
    Id: result.Id,
  }),
  graphqlDocument: InsertCommentDocument,
  graphqlVariables: (input: InsertCommentInput) => ({
    Content: input.Content,
    ConversationId: input.ConversationId,
  }),
  mapGraphqlResponse: (data: InsertCommentMutation): { Id: string } => {
    if (!data.insert_comment_one) {
      throw new Error('Failed to insert comment');
    }

    return { Id: data.insert_comment_one.Id };
  },
});
